import { Component } from 'react'
import PropTypes from 'prop-types'
import ImageUploadPreviewer from 'shared/image-upload-previewer/image-upload-previewer'
import { Input } from 'components/forms'
import css from './reg-item-form.scss'
import CategorySelector from './category-selector'

export default class ExternalRegistryFields extends Component {
  static propTypes = {
    categories: PropTypes.array,
    regItem: PropTypes.object,
    onRegItemChange: PropTypes.func.isRequired,
    onNewCategoryChange: PropTypes.func.isRequired,
  }

  onImageChange = ({ imgUrl }) => {
    this.props.onRegItemChange({ imgUrl })
  }

  handleChange = (e) => {
    this.props.onRegItemChange({ [e.target.name]: e.target.value })
  }

  render() {
    const regItemFields = this.props.regItem

    return (
      <>
        <div className={css.item}>
          <div className={css.imageContainer}>
            <ImageUploadPreviewer
              imgUrl={regItemFields.imgUrl}
              onChange={this.onImageChange}
            />
          </div>

          <div className={css.itemFields}>
            <Input
              error={regItemFields.title ? null : 'Title cannot be blank'}
              label="Title"
              name="title"
              value={regItemFields.title}
              onChange={this.handleChange}
            />

            <CategorySelector
              categories={this.props.categories}
              name="categoryId"
              value={regItemFields.categoryId}
              onCategoryAdd={this.props.onNewCategoryChange}
              onCategoryChange={this.props.onRegItemChange}
            />
          </div>
        </div>

        <Input
          error={regItemFields.url ? null : 'Url cannot be blank'}
          groupClassName="mbl"
          label="Url"
          name="url"
          value={regItemFields.url}
          onChange={this.handleChange}
        />

        <Input
          className={css.notes}
          label="Notes"
          name="description"
          placeholder="Tell Gift Givers what they should know about this registry."
          type="textarea"
          value={regItemFields.description || ''}
          onChange={this.handleChange}
        />
      </>
    )
  }
}
